"use client";

import React, { useEffect, useState } from "react";

export default function ScreenshotShield({ visible }: { visible: boolean }) {
  // Lock background scroll/interaction while the shield is up.
  useEffect(() => {
    if (!visible) return;
    const prev = document.body.style.overflow;
    document.body.style.overflow = "hidden";
    return () => {
      document.body.style.overflow = prev;
    };
  }, [visible]);

  // Wordmark with graceful fallback if the asset 404s.
  const [imgOk, setImgOk] = useState(true);
  useEffect(() => {
    if (visible) setImgOk(true);
  }, [visible]);

  if (!visible) return null;

  return (
    <div
      role="alert"
      aria-live="assertive"
      className="fixed inset-0 z-[1000] flex items-center justify-center pointer-events-none"
    >
      {/* Subtle watermark-style guard — lighter than the previous bg-black/30
          backdrop-blur-xl which made content look permanently stuck. */}
      <div className="absolute inset-0 bg-black/5" aria-hidden="true" />
      <div className="relative z-10 flex flex-col items-center gap-4 p-6">
        {imgOk ? (
          <img
            src="/uniui_original_remastered_wordmark.png"
            alt="UNIUI"
            className="h-32 w-auto drop-shadow-lg"
            onError={() => setImgOk(false)}
          />
        ) : (
          <span className="text-4xl font-black tracking-tight text-white drop-shadow-lg">
            UNIUI
          </span>
        )}
        <p className="max-w-xs text-center text-sm font-semibold text-white">
          Screenshot detected — Content watermarked and traceable. Use the Share
          button instead.
        </p>
      </div>
    </div>
  );
}
